import React from 'react';

export default function BookStipendInfoModalContent() {
  return (
    <p>
      You may be eligible for money to cover books and supplies, up to $83 per
      month.
    </p>
  );
}
